import { Controller } from '@hotwired/stimulus';

type SystemStatus = {
  status: 'NORMAL' | 'PLANNED';
  message?: string;
};

export default class extends Controller {
  declare messageTarget: HTMLElement;

  declare urlValue: string;

  static targets = ['message'];

  static values = { url: String };

  connect(): void {
    void this.#checkSystemStatus();
  }

  async #checkSystemStatus(): Promise<void> {
    const response = await fetch(this.urlValue);
    const data = (await response.json()) as SystemStatus;

    if (data.status === 'PLANNED' && data.message) {
      this.messageTarget.textContent = data.message;
      this.element.classList.remove('u-hidden');
    }
  }
}
